import { Modal } from 'ant-design-vue'
import type { ModalOptions } from 'ant-design-vue/types/modal'

type ModalType = 'confirm' | 'error' | 'info' | 'success' | 'warning'

export function useModal() {
  const bodyElement = document.querySelector('body')
  const widthStyle = 'width: calc(100% - 15px)'

  const isScrollVisible = (element: HTMLElement) =>
    element.scrollHeight > element.clientHeight

  const addModalVisibilityListener = () => {
    const observer = new MutationObserver(() => {
      const body = document.querySelector('body')
      const header = document.querySelector('.header')

      if (!body || !header) return

      if (
        isScrollVisible(body) &&
        body.getAttribute('style')?.includes(widthStyle)
      ) {
        header.setAttribute('style', widthStyle)
      } else {
        header.setAttribute('style', '')
      }
    })

    if (!bodyElement) return

    observer.observe(bodyElement, {
      attributes: true
    })

    return observer
  }

  const removeModalVisibilityListener = (observer?: MutationObserver) =>
    observer && observer.disconnect()

  const showInformationModal = (type: ModalType, params: ModalOptions) =>
    Modal[type]({ ...params, centered: true })

  return {
    addModalVisibilityListener,
    removeModalVisibilityListener,
    showInformationModal
  }
}
